import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const setOpenModal = createAction('modals/setOpenModal', (modal, isOpen) => ({
  payload: {
    modal,
    isOpen,
  },
}));
